import { URLS } from 'api/constants';
import { IRegionItem } from 'constants/types';
import { apiGet } from './client';
import { PaginationResponse } from './types';

export async function listLicenses() {
  return apiGet<PaginationResponse<string>>(URLS.LICENSES);
}

export async function listSoftware() {
  return apiGet<PaginationResponse<string>>(URLS.SOFTWARE);
}

export async function listCountries() {
  const data = await apiGet<IRegionItem[] | PaginationResponse<IRegionItem>>(
    URLS.COUNTRIES
  );

  if (Array.isArray(data)) {
    return data;
  }

  return data?.results ?? [];
}
